import React from 'react'
import { Link } from 'react-router-dom'
import styles from './IconButton.module.scss'

export default function IconButton({
	variant = 'default',
	to,
	type,
	onClick,
	className = '',
	children,
	...rest
}) {
	return (
		<>
			{to ? (
				<Link
					to={to}
					variant={variant}
					className={`${styles.IconButton} ${className}`}
					{...rest}
				>
					{children}
				</Link>
			) : (
				<button
					variant={variant}
					className={`${styles.IconButton} ${className}`}
					type={type}
					onClick={onClick}
					{...rest}
				>
					{children}
				</button>
			)}
		</>
	)
}
